module.exports = __webpack_public_path__ + "img/ReviewDetails_4.0205d539.png";